import { createSlice } from '@reduxjs/toolkit'

import { getCoachCertifications, getCoachCertification, generateKit } from '../actions/coachCertificationActions'

const initialState = {
  certifications: [],
  listStatus: 'idle',
  certification: null,
  requestedId: null,
  notFound: false,
  failed: false,
  kitStatus: 'idle',
}

const coachCertificationSlice = createSlice({
  name: 'coachCertification',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCoachCertifications.pending, (state) => { state.listStatus = 'loading' })
      .addCase(getCoachCertifications.fulfilled, (state, action) => {
        state.certifications = action.payload.certifications
        state.listStatus = 'loaded'
      })
      .addCase(getCoachCertifications.rejected, (state) => { state.listStatus = 'failed' })
      .addCase(getCoachCertification.pending, (state, action) => {
        if (action.meta.arg !== state.certification?.id) { state.kitStatus = 'idle' }
        state.requestedId = action.meta.arg
        state.notFound = false
        state.failed = false
      })
      .addCase(getCoachCertification.fulfilled, (state, action) => {
        if (action.meta.arg === state.requestedId) { state.certification = action.payload.certification }
      })
      .addCase(getCoachCertification.rejected, (state, action) => {
        state.notFound = action.payload?.status === 404
        state.failed = !state.notFound
      })
      .addCase(generateKit.pending, (state) => { state.kitStatus = 'loading' })
      .addCase(generateKit.fulfilled, (state) => { state.kitStatus = 'ready' })
      .addCase(generateKit.rejected, (state) => { state.kitStatus = 'failed' })
  },
})

export default coachCertificationSlice.reducer
